/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-11 16:05:53
 * @LastEditTime: 2024-09-26 20:03:18
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\verifyIdentity\index.tsx
 * @Description: 忘记密码页面
 */

import { CommmonGet } from "@/util/network/api";
import { CheckIdCard, CheckPhone } from "@/util/public";
import { Form, message } from "antd";
import { LgButton, LgInput } from "lancoo-web-ui";
import { useEffect, useState } from "react";
import { service } from "../data";
import SecureIcon from '../images/安全.svg';
import PhoneIcon from '../images/手机.svg';
import CardIcon from '../images/证件.svg';

function VerifyIdentity(props: any) {
  const {
    form,
    setIsloading,
    onUpPassword
  } = props;

  const [countdown, setCountdown] = useState<number>(60); // 倒计时秒数
  const [timingShow, setTimingShow] = useState<boolean>(false);

  const submit = () => {
    form.validateFields().then((values) => {
      setIsloading(true);
      CommmonGet(service.verifyIdentity, values).then((res) => {
        message.success("身份验证成功");
        onUpPassword(values.idCard, values.newPhone);
      }).catch((error) => {
        console.log(error);
        if (error.msg) {
          message.warning(error.msg, 2);
        } else {
          message.warning('身份验证失败', 2);
        }
      })
    }).catch(error => {
      console.log(error);
    }).finally(() => {
      setIsloading(false);
    });
  }

  useEffect(() => {
    const formData = form.getFieldsValue();
    form.setFieldsValue({
      ...formData,
      idCard: '',
      newPhone: '',
      code: '',
    });
  }, []);

  /**
    * @description: 获取忘记密码手机验证码
    * @param {*} void
    * @return {*}
    */
  const getRegisterCode = (): void => {
    // 禁用获取验证码按钮
    const formData = form.getFieldsValue();
    if (formData.newPhone) {
      if (!CheckPhone(formData.newPhone)) {
        message.warning('手机号格式有误', 2);
        return;
      }
      setIsloading(true);
      CommmonGet(service.sendForgetOldPhoneSmsCode, {
        newPhone: formData.newPhone
      }).then(res => {
        message.success("发送成功");
        startCountdown();
      }).catch(error => {
        if (error.msg) {
          message.warning(error.msg, 2);
        }
      }).finally(() => {
        setIsloading(false);
      });
    } else {
      message.warning('请输入手机号', 2);
    }
  };

  /**
    * @description: 倒计时
    * @return {*}
    */
  const startCountdown = () => {
    setTimingShow(true)
    let timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    setTimeout(() => {
      setTimingShow(false)
      clearInterval(timer);
      setCountdown(60); // 重置倒计时秒数为60
    }, countdown * 1000);
  };

  return (
    <>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon'
      >
        <div className='form_icon_div' style={{ background: `url(${CardIcon}) no-repeat center` }} />
        <Form.Item
          name="idCard"
          rules={[
            { required: true, message: '身份证号不能为空' },
            () => ({
              validator(_, value) {
                if (!value || !CheckIdCard(value)) {
                  return Promise.resolve();
                } else if (value && CheckIdCard(value)) {
                  return Promise.reject(new Error(CheckIdCard(value)));
                }
                return Promise.reject(new Error('身份证格式有误'));
              },
            }),
          ]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请输入完整身份证号" }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
      </Form.Item>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon'
      >
        <div className='form_icon_div' style={{ background: `url(${PhoneIcon}) no-repeat center` }} />
        <Form.Item
          name="newPhone"
          rules={[
            { required: true, message: '请输入新手机号' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || CheckPhone(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('手机号格式有误'));
              },
            }),
          ]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请输入新手机号" }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
      </Form.Item>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon form_iconMa'
      >
        <div className='form_icon_div' style={{ background: `url(${SecureIcon}) no-repeat center` }} />
        <Form.Item
          name="code"
          rules={[{ required: true, message: '请输入验证码' }]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请输入验证码" }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
        <span style={{
          position: 'absolute',
          top: 0,
          right: '16px',
          lineHeight: '48px'
        }}>
          {timingShow ?
            <div
              className='onclik_cls'
              style={{
                color: '#999999',
                cursor: 'default'
              }}
            >
              ({countdown}秒后重新获取)
            </div> :
            <div
              onClick={getRegisterCode}
              className='onclik_cls'
            >
              获取验证码
            </div>
          }
        </span>
      </Form.Item>

      <Form.Item style={{ marginBottom: 22 }}>
        <LgButton
          onClick={submit}
          backgroundType='opacification'
          type='info'
          size='super'
          style={{ justifyContent: 'center', width: 360 }}
        >
          确认
        </LgButton>
      </Form.Item>
    </>
  )
}

export default VerifyIdentity
